<script setup lang="ts">
import { AppFlicker } from '@libs/ui';
</script>

<template>
  <div class="static-suggested-activities-banner-loader">
    <div class="header">
      <div class="header-title-loader">
        <div class="title-loader">
          <AppFlicker
            width="100%"
            height="100%"
            border-radius="border-radius-8"
          />
        </div>
        <div class="subtitle-loader">
          <AppFlicker
            width="100%"
            height="100%"
            border-radius="border-radius-8"
          />
        </div>
      </div>

      <div class="button-loader">
        <AppFlicker
          width="100%"
          height="100%"
          border-radius="border-radius-8"
        />
      </div>
    </div>
    <div class="activities-wrapper">
      <div v-for="n in 3" :key="n" class="activity-card-loader">
        <AppFlicker
          width="100%"
          height="100%"
          border-radius="border-radius-8"
          class="image-loader"
        />
        <AppFlicker
          width="spacing-64"
          height="spacing-16"
          border-radius="border-radius-8"
          class="name-loader"
        />
        <AppFlicker
          width="spacing-96"
          height="spacing-16"
          border-radius="border-radius-8"
          class="name-loader"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.static-suggested-activities-banner-loader {
  display: flex;
  margin-bottom: var(--spacing-32);
  gap: var(--spacing-32);
  padding: var(--spacing-24) 20px var(--spacing-24) 74px;
  background-color: var(--color-white);
  border-top: 1px solid var(--color-scrollbar);
  border-bottom: 1px solid var(--color-scrollbar);
  justify-content: space-between;
  max-height: 338px;
  position: relative;
  z-index: 2;

  @include for-less-or-equal-than-599-px {
    padding: var(--spacing-16);
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--spacing-24);
    width: 230px;
    height: 290px;
    @include for-less-or-equal-than-599-px {
      padding: var(--spacing-16);
      height: 156px;
    }
    .header-title-loader {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-8);
      .title-loader {
        width: 117px;
        height: 19px;
      }
      .subtitle-loader {
        width: 200px;
        height: 30px;
      }
    }

    .button-loader {
      width: 146px;
      height: 44px;
    }
  }

  .activities-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: var(--spacing-12);

    @include for-less-or-equal-than-1536-px {
      grid-template-columns: 1fr 1fr;
      .activity-card-loader:last-child {
        display: none;
      }
    }

    @include for-less-or-equal-than-900-px {
      grid-template-columns: 1fr;
      .activity-card-loader:nth-last-child(-n + 2) {
        display: none;
      }
    }

    @include for-less-or-equal-than-599-px {
      display: none;
    }

    .activity-card-loader {
      display: flex;
      gap: var(--spacing-8);
      flex-direction: column;
      padding: var(--spacing-12);
      border-radius: var(--border-radius-12);
      border: 1px solid var(--color-scrollbar);
      width: 296px;
      height: 290px;

      .image-loader {
        flex: 1;

        aspect-ratio: 5/4;
        width: 100%;
        height: auto;
      }

      .name-loader {
        padding: var(--spacing-8);
      }
    }
  }
}
</style>
